import { render, staticRenderFns } from "./MyAuth.vue?vue&type=template&id=039ed811&scoped=true&"
import script from "./MyAuth.vue?vue&type=script&lang=js&"
export * from "./MyAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039ed811",
  null
  
)

export default component.exports